import { render, staticRenderFns } from "./ContratosPantalla.vue?vue&type=template&id=d9c1da14&"
import script from "./ContratosPantalla.vue?vue&type=script&lang=ts&"
export * from "./ContratosPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('d9c1da14', component.options)
    } else {
      api.reload('d9c1da14', component.options)
    }
    module.hot.accept("./ContratosPantalla.vue?vue&type=template&id=d9c1da14&", function () {
      api.rerender('d9c1da14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/SucursalVirtual/Contratos/ContratosPantalla.vue"
export default component.exports